import React, { useState } from "react";
import CommentsList from "./CommentsList";
import CommentsSortButton from "../CommentsSortButton";

// import {fetchAndCleanData} from "../../../viewcommentshelpers";
export default function CommentsView({
   commentsView,
   CommentButton,
   HistoryButton,
   comments,
   users,
   setComments,
   projectId,
   sectionId,
   getComments,
}) {
   // Stateful data

   // Switch between views based on this value, comments view by default
   // Sort Options - options (desc, asc)
   // True - most recent to oldest | False - oldest to most recent
   const [sortBy, setSortBy] = useState("desc");

   //Functions
   function toggleSort(sortType) {
      setSortBy(sortType);
      setComments(comments.reverse());
   }

   if (!commentsView) {
      return null;
   }
   return (
      <section className="comments-view">
         <div className="comments-view-top">
            <div>
               {CommentButton}
               {HistoryButton}
            </div>
            <CommentsSortButton
               setSortBy={setSortBy}
               toggleSort={toggleSort}
               sortBy={sortBy}
            />
         </div>

         {users && (
            <CommentsList
               getComments={getComments}
               sectionId={sectionId}
               users={users}
               comments={comments}
               projectId={projectId}
            />
         )}
      </section>
   );
}
